export default "__VITE_ASSET__BJMVRJf7__"